import { Panel } from '@playcanvas/pcui/react';
import React from 'react';

import { SetProperty, ObserverData } from '../../types';
import TexturePanel from './texture-panel';
import FilesPanel from './files-panel';
import MaterialsPanel from './materials-panel';
import LodsPanel from './lods-panel';

interface AssetsPanelProps {
    observerData: ObserverData;
    setProperty: SetProperty;
}

class AssetsPanel extends React.Component<AssetsPanelProps> {
    shouldComponentUpdate(nextProps: Readonly<AssetsPanelProps>): boolean {
        return (
            JSON.stringify(nextProps.observerData.lods) !== JSON.stringify(this.props.observerData.lods) ||
            JSON.stringify(nextProps.observerData.files) !== JSON.stringify(this.props.observerData.files) ||
            JSON.stringify(nextProps.observerData.scene.materials) !== JSON.stringify(this.props.observerData.scene.materials) ||
            JSON.stringify(nextProps.observerData.scene.textures) !== JSON.stringify(this.props.observerData.scene.textures)
        );
    }

    render() {
        const { observerData, setProperty } = this.props;
        const { scene, lods, files } = observerData;
        
        // Check if any assets are loaded to determine if panel should be enabled
        const hasAssets = (
            lods?.available?.length > 0 ||
            files?.list?.length > 0 ||
            scene?.materials?.length > 0 ||
            scene?.textures?.length > 0
        );

        return (
            <Panel 
                headerText='ASSETS' 
                class='scene-assets-panel' 
                enabled={hasAssets}
                collapsible={true}
                collapsed={true}
            >
                <LodsPanel lodsData={lods} setProperty={setProperty} />
                <FilesPanel filesData={files} setProperty={setProperty} />
                <MaterialsPanel sceneData={scene} setProperty={setProperty} />
                <TexturePanel sceneData={scene} setProperty={setProperty} />
            </Panel>
        );
    }
}

export default AssetsPanel; 